import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColors from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        margin: theme.spacing(4, 0),
      },
      box: {
        borderRadius: 4,
        backgroundColor: 'white',
      },
      title: {
        fontWeight: 'bold',
        fontSize: 12,
        color: sicrediColors.secondarySicrediDarker,
        letterSpacing: 0.25,
        lineHeight: '16px',
        padding: theme.spacing(2, 1),
        borderBottomWidth: 16,
        borderBottomColor: '#F8F9F7',
        whiteSpace: 'pre-wrap',
      },
      data: {
        fontWeight: 300,
        fontSize: 12,
        color: sicrediColors.secondarySicrediDark,
        letterSpacing: 0.44,
        lineHeight: 1.2,
        padding: theme.spacing(1.5, 1),
      },
      actions: {
        padding: theme.spacing(0, 1),
        whiteSpace: 'nowrap',
      },
      action: {
        fontSize: 16,
        padding: theme.spacing(1.5),
      },
      advice: {
        textAlign: 'center',
        borderRadius: 4,
        backgroundColor: 'white',
        lineHeight: 1.5,
        color: sicrediColors.secondarySicrediDark,
        padding: theme.spacing(1.5),
        '& svg': {
          color: sicrediColors.primarySicredi,
          width: 24,
          height: 24,
          marginRight: theme.spacing(1.5),
          verticalAlign: 'middle',
        }
      },
      footer: {
        borderBottom: 'none',
      },
      paginacao: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      },
      paginacaoPrev: {
        width: 16,
        height: 16,
        transform: 'rotate(90deg)',
      },
      paginacaoNext: {
        width: 16,
        height: 16,
        transform: 'rotate(-90deg)',
      },
      paginacaoNumber: {
        minWidth: 'unset',
      },
    }),
  { name: 'HomeAssessorTabela' }
);
